module.exports = __webpack_public_path__ + "img/conteudo-estrela-direita.72c16174.png";